import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { getLinkIconOptions } from '../shared/linkIcons';

/**
 * Dropdown for selecting a link icon. Shows each option WITH its icon (brand image or Bootstrap icon)
 * so the user can see their brand icons in the list.
 */
export default function LinkIconDropdown({ value, onChange, accountImages = [], t, size = 'sm', ariaLabel }) {
  const [open, setOpen] = useState(false);
  const options = getLinkIconOptions(accountImages, t);

  const selected = options.find((opt) => String(opt.value) === String(value)) || options[0];

  const renderIcon = (opt) => {
    if (opt.iconUrl) {
      return (
        <img
          src={opt.iconUrl}
          alt=""
          style={{ width: 20, height: 20, objectFit: 'contain', flexShrink: 0 }}
          onError={(e) => { e.target.style.display = 'none'; }}
        />
      );
    }
    return (
      <i
        className={`bi ${opt.iconClass || 'bi-link-45deg'}`}
        style={{ fontSize: '1.1rem', width: 20, textAlign: 'center', flexShrink: 0 }}
      />
    );
  };

  return (
    <Dropdown show={open} onToggle={(isOpen) => setOpen(isOpen)} className="link-icon-dropdown">
      <Dropdown.Toggle
        variant="outline-secondary"
        size={size}
        id={`link-icon-dd-${value || 'default'}`}
        aria-label={ariaLabel || (t && t('planDetail.activityModals.linkIcon', { defaultValue: 'Icon' }))}
        className="d-flex align-items-center gap-2 text-start"
        style={{ minWidth: 140 }}
      >
        {renderIcon(selected)}
        <span className="text-truncate flex-grow-1">{selected?.label || 'Default'}</span>
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {options.map((opt, idx) => (
          <Dropdown.Item
            key={opt.iconUrl ? `url-${idx}` : (opt.value || 'default')}
            onClick={() => {
              onChange(opt.value);
              setOpen(false);
            }}
            active={String(opt.value) === String(value)}
            className="d-flex align-items-center gap-2"
          >
            {renderIcon(opt)}
            <span>{opt.label}</span>
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}
